import {Component, HostBinding, Input} from '@angular/core';
import {ContractStatus} from "@shared-types/contract-status";

@Component({
  selector: 'chip',
  standalone: true,
  imports: [],
  templateUrl: './chip.component.html',
  styleUrl: './chip.component.scss'
})
export class ChipComponent {
  @Input() status: ContractStatus = ContractStatus.CHECK;
  @Input() selected: boolean = false;
  @HostBinding('class.selected') get isSelected() {
    return this.selected;
  }
  @HostBinding('class.red') get isRed() {
    return this.status === ContractStatus.NO
  };
  @HostBinding('class.green') get isGreen() {
    return this.status === ContractStatus.YES;
  };
  @HostBinding('class.orange') get isOrange() {
    return this.status === ContractStatus.CHECK
  }
}
